import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'

import closeGlobalMessage from '../../actions/globalMessage/closeGlobalMessage'

import GlobalMessage from '../../components/GlobalMessage'

export const mapStateToProps = (state: ReduxStoreInterface) => ({
  serviceStatus: state.serviceStatus,
})

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeGlobalMessage: () => {
    dispatch(closeGlobalMessage())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GlobalMessage)
